export default __webpack_public_path__ + "static/media/uncle.fa644765.ogg";